<template>
  <div class="grid gap-8">
    <i18n-t
      class="font-bold text-primary-950 md:text-2xl"
      keypath="course.page.header.title"
      tag="h2"
    >
      <template #title>
        <span
          class="mb-4 block max-w-[950px] font-title text-3xl leading-snug sm:text-4xl/tight md:text-5xl/tight"
        >
          {{ course.title }}
        </span>
      </template>

      <template #teacherFullName>
        <strong class="font-bold">
          {{ course.teacher.full_name }}
        </strong>
      </template>

      <template #teacherJob>
        <span class="mr-2 font-normal">
          {{ course.teacher.job }}
        </span>

        <span class="inline-flex gap-2 align-middle">
          <teacher-companies-logos
            :companies="course.teacher.companies"
            :height="35"
          />
        </span>
      </template>
    </i18n-t>

    <div class="flex flex-wrap items-center gap-2">
      <nuxt-link v-if="course.ratings" data-cy-rating-chip to="#ratings">
        <course-rating-chip
          v-tooltip="
            $t('course.ratings.tooltip_label', {
              value: useI18nNumber(course.ratings.avg, {
                maximumFractionDigits: 1,
              }).value,
              count: course.ratings.count,
            })
          "
          :total-number-of-ratings="course.ratings.count"
          :value="course.ratings.avg"
        />
      </nuxt-link>
      <course-online-type-chip v-if="nextSession?.is_online" />
      <course-format-chip :format="course.format" />
      <course-session-date-chip
        v-if="nextSession"
        class="lg:hidden"
        :session="nextSession"
      />
      <place-address-chip
        v-if="nextSession?.place"
        :address="nextSession.place.address"
        class="lg:hidden"
        field="city"
      />
      <course-language-chip
        data-cy-course-languages
        :languages="course.languages"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18nNumber } from "#imports";
import type { CoursePageView } from "~/business-areas/course/course.model";

defineProps<{
  course: CoursePageView;
  nextSession?: CoursePageView["sessions"][0];
}>();
</script>
